'use client';

import { MessageSquare, MoreVertical } from 'lucide-react';
import { Button } from '../button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../dropdown-menu';
import { useChatTriggerState } from './state';
import { IFanConversationSet } from '@ui/components/organisms';

type ChatTriggerProps = {
  fanName: string;
  fanId: string;
  fanAvatar: string;
  currentCommunityCreatorId: string;
  groupChats: IFanConversationSet[];
};

export function ChatTrigger(props: ChatTriggerProps) {
  const { onChat, onAddToGroup } = useChatTriggerState();
  return (
    <div className="flex gap-1 items-center">
      <Button
        variant="default"
        className="h-fit gap-2 bg-primary hover:bg-primary/90 px-2 py-2"
        onClick={() =>
          onChat({
            fanId: props.fanId,
            fanName: props.fanName,
            fanAvatar: props.fanAvatar,
            currentCommunityCreatorId: props.currentCommunityCreatorId,
          })
        }>
        <MessageSquare className="w-4 h-4" />
        Message
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="px-1 py-2 rounded-sm h-fit">
            <MoreVertical className="w-4 h-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            onClick={() =>
              onAddToGroup({
                fanId: props.fanId,
                fanName: props.fanName,
                currentCommunityCreatorId: props.currentCommunityCreatorId,
                fanAvatar: props.fanAvatar,
              })
            }>
            Add {props.fanName} to group
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
